;(function() {

  var popup = document.querySelector('#cart-terms-popup');

  window.TERMSPOPUP = {
    isOpen: false,
    acceptBtn: popup.querySelector('[data-accept-terms]'),
    closeBtns: popup.querySelectorAll('[data-close-terms]'),
    callback: function() { console.log('NO TERMSPOPUP CALLBACK DEFINED') },

    setScope: function() {
      this.callback = this.callback.bind(this);
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.accept = this.accept.bind(this);
      this.addEventListeners = this.addEventListeners.bind(this);
      this.removeEventListeners = this.removeEventListeners.bind(this);
    },

    open: function(callback) { 
      this.setScope();

      document.body.style.overflow = 'hidden';
      popup.classList.add('open'); 
      this.isOpen = true;

      this.addEventListeners();

      if ( callback ) this.callback = callback;
    },

    close: function() { 
      document.body.style.overflow = 'auto';
      popup.classList.remove('open'); 
      this.isOpen = false;

      this.removeEventListeners();
    },

    toggle: function() {
      if ( this.isOpen ) this.close();
      else this.open();
    },

    accept: function() {
      this.close();
      this.callback();
    },

    addEventListeners: function() {
      this.acceptBtn.addEventListener('click', this.accept);

      for (const closeBtn of this.closeBtns) {
        closeBtn.addEventListener('click', this.close);
      }
    },

    removeEventListeners: function() {
      this.acceptBtn.removeEventListener('click', this.accept);
      
      for (const closeBtn of this.closeBtns) {
        closeBtn.removeEventListener('click', this.close);
      }
    }
  };
  
})();